import { useDispatch, useSelector } from 'react-redux';
import ky from 'ky';

import { RootState } from '../redux/rootReducer';
import { generateCardTemplateId, addCardTemplate } from '../redux/cardTemplateDbSlice';
import { addCardTemplateAttribute } from '../redux/cardTemplateAttributeDbSlice';
import { addCardTemplateShape } from '../redux/cardTemplateShapeDbSlice';
import { addRelationUserCardTemplate } from '../redux/relationUserCardTemplateDbSlice';
import { addRelationPaletteCardTemplate } from '../redux/relationPaletteCardTemplateDbSlice';
import { addRelationUserImage } from '../redux/relationUserImageDbSlice';
import { addImage, loadImage } from '../redux/imageDbSlice';
import { generateBookId, addBook } from '../redux/bookDbSlice';
import { addRelationUserBook } from '../redux/relationUserBookDbSlice';
import { addRelationFolderBook } from '../redux/relationFolderBookDbSlice';
import { addSheetTree } from '../redux/sheetTreeDbSlice';
import { generateSheetId, addSheet } from '../redux/sheetDbSlice';
import { addSheetInformation } from '../redux/sheetInformationDbSlice';
import { generateCardId, addCard } from '../redux/cardDbSlice';
import { addCardAttribute } from '../redux/cardAttributeDbSlice';
import { addCardShape } from '../redux/cardShapeDbSlice';
import { addMemoCardContent } from '../redux/memoCardContentDbSlice';
import { addDrawCardContent } from '../redux/drawCardContentDbSlice';
import { addArrow } from '../redux/arrowDbSlice';
import { generatePaletteId, addPalette } from '../redux/paletteDbSlice';
import { addRelationUserPalette } from '../redux/relationUserPaletteDbSlice';
import { getLoginCheckData } from '../redux/workBackendSlice';
import { PurchaseLoadPayload, loadPurchase } from '../redux/shopSlice';
import useCurrentUserId from './useCurrentUserId';

import { apiURL } from '../components/DigimagiProvider';
import { Hash, setTokensToCookie } from '../general';

const useInstallGoods = () => {
  const dispatch = useDispatch();
  const currentUserId = useCurrentUserId();
  const rPCTs = useSelector((state: RootState) => state.relationPaletteCardTemplateDb.relationPaletteCardTemplates);
  const rUIs = useSelector((state: RootState) => state.relationUserImageDb.relationUserImages);
  const rFBs = useSelector((state: RootState) => state.relationFolderBookDb.relationFolderBooks);
  const rUPs = useSelector((state: RootState) => state.relationUserPaletteDb.relationUserPalettes);

  type InstallGoodsProps = {
    sendData: { list: [string, number | 'latest'][] };
    paletteId?: string;
    folderId?: string;
    localUserId?: string;
    initialize?: boolean;
  }
  const installGoods = async (props: InstallGoodsProps) => {
    try {
      const { sendData, paletteId, folderId, localUserId, initialize } = props;
      const userId = currentUserId ? currentUserId : localUserId;
      console.log(userId)
      if (!userId) return;
      const loginCheckData = getLoginCheckData();
      const query = await ky.post(`${apiURL}install_goods`, { json: { ...sendData, ...loginCheckData, initialize } }).json() as any;
      const res = query.data
      const hash = res.data as Hash<any>;

      const newToken = res.newToken;
      if (newToken && typeof newToken === 'object') setTokensToCookie(newToken);

      console.log(hash)
      console.log(paletteId, folderId)

      type DataType = { id: string; jdoc: string; original_id: string; goods_id: string; version: number; }

      const arrows = hash.arrows as { id: string; jdoc: string; goods_id: string; version: number; }[];
      const books = hash.books as DataType[];
      const bundles = hash.bundles as { id: string; jdoc: string }[];
      const cardAttributes = hash.card_attributes as { id: string; jdoc: string; goods_id: string; version: number; }[];
      const cardShapes = hash.card_shapes as { id: string; jdoc: string; goods_id: string; version: number; }[];
      const cardTemplateAttributes = hash.card_template_attributes as { id: string; jdoc: string; goods_id: string; version: number; parentId?: string; }[];
      const cardTemplateShapes = hash.card_template_shapes as { id: string; jdoc: string; goods_id: string; version: number; parentId?: string; }[];
      const cardTemplates = hash.card_templates as (DataType & { parentId?: string; })[];
      const cards = hash.cards as DataType[];
      const drawCardContents = hash.draw_card_contents as { id: string; jdoc: string; goods_id: string; version: number; }[];
      const goods = hash.goods as { id: string }[];
      const images = hash.images as DataType[];
      const memoCardContents = hash.memo_card_contents as { id: string; jdoc: string; goods_id: string; version: number; }[];
      const palettes = hash.palettes as { id: string; name: string; bundle_goods: string; goods_id: string; version: number; }[];
      const sheetInformations = hash.sheet_informations as { id: string; jdoc: string; goods_id: string; version: number; }[];
      const sheetTrees = hash.sheet_trees as { id: string; jdoc: string; goods_id: string; version: number; }[];
      const sheets = hash.sheets as DataType[];
      const purchases = hash.purchases as PurchaseLoadPayload[];

      const replacedIds: Hash<string> = {};
      const rPCTStartOrder = Object.keys(rPCTs).filter(id => rPCTs[id].paletteId === paletteId).length;
      const rFBStartOrder = Object.keys(rFBs).filter(id => rFBs[id].folderId === folderId).length;
      const rUPStartOrder = Object.keys(rUPs).length;

      palettes.forEach((data, ix) => {
        const newId = generatePaletteId();
        replacedIds[data.id] = newId;
        const order = initialize ? rUPStartOrder + 2 + ix : rUPStartOrder + ix;
        dispatch(addPalette({ id: newId, name: data.name, standard: false, goodsId: data.goods_id, version: data.version }));
        dispatch(addRelationUserPalette({ userId, paletteId: newId, order }));
      })

      const rPCTOrders: Hash<number> = {};
      if (paletteId) rPCTOrders[paletteId] = rPCTStartOrder;
      cardTemplates.forEach(data => {
        const value = JSON.parse(data.jdoc);
        const newId = generateCardTemplateId();
        console.log(data.original_id, newId)
        replacedIds[data.original_id + data.parentId] = newId;
        dispatch(addCardTemplate({ ...value, id: newId, goodsId: data.goods_id, version: data.version }));
        dispatch(addRelationUserCardTemplate({ userId, cardTemplateId: newId }));
        if (data.parentId && replacedIds[data.parentId]) {
          if (!rPCTOrders[data.parentId]) rPCTOrders[data.parentId] = 0;
          dispatch(addRelationPaletteCardTemplate({ paletteId: replacedIds[data.parentId], cardTemplateId: newId, order: rPCTOrders[data.parentId] }));
          rPCTOrders[data.parentId]++;
        } else if (paletteId) {
          dispatch(addRelationPaletteCardTemplate({ paletteId: paletteId, cardTemplateId: newId, order: rPCTOrders[paletteId] }));
          rPCTOrders[paletteId]++;
        }
      })

      const doneImages: string[] = [];
      images.forEach(data => {
        const value = JSON.parse(data.jdoc);
        const exists = Object.keys(rUIs).find(id => rUIs[id].imageId === data.original_id && rUIs[id].userId === userId);
        if (exists || doneImages.includes(data.goods_id)) return;
        dispatch(addRelationUserImage({ userId, imageId: data.original_id }));
        if (initialize) dispatch(addImage({ ...value, id: data.original_id, goodsId: data.goods_id, version: data.version }));
        else dispatch(loadImage({ ...value, id: data.original_id }));
        doneImages.push(data.goods_id);
      })
      cardTemplateAttributes.forEach(data => {
        const value = JSON.parse(data.jdoc);
        if (!('cardTemplateId' in value)) return;
        dispatch(addCardTemplateAttribute({ ...value, cardTemplateId: replacedIds[value.cardTemplateId + data.parentId], goodsId: data.goods_id, version: data.version }));
      })
      cardTemplateShapes.forEach(data => {
        const value = JSON.parse(data.jdoc);
        if (!('cardTemplateId' in value)) return;
        dispatch(addCardTemplateShape({ ...value, cardTemplateId: replacedIds[value.cardTemplateId + data.parentId], goodsId: data.goods_id, version: data.version }));
      })
      purchases.forEach(data => {
        if (!data) return;
        dispatch(loadPurchase(data));
      })
      books.forEach((data, ix) => {
        const value = JSON.parse(data.jdoc);
        const newId = generateBookId();
        console.log(data.original_id, newId)
        replacedIds[data.original_id] = newId;
        const order = initialize ? rFBStartOrder + 1 + ix : rFBStartOrder + ix;
        dispatch(addBook({ ...value, id: newId, goodsId: data.goods_id, version: data.version }));
        dispatch(addRelationUserBook({ userId, bookId: newId }));
        if (folderId) dispatch(addRelationFolderBook({ userId, folderId: folderId, bookId: newId, order }));
      })
      sheets.forEach(data => {
        const value = JSON.parse(data.jdoc);
        const newId = generateSheetId();
        replacedIds[data.original_id] = newId;
        dispatch(addSheet({ ...value, id: newId, goodsId: data.goods_id, version: data.version }));
      })
      sheetTrees.forEach(data => {
        const value = JSON.parse(data.jdoc);
        if (!('bookId' in value) || !('sheetId' in value)) return;
        if ('parentSheetId' in value) dispatch(addSheetTree({ ...value, bookId: replacedIds[value.bookId], sheetId: replacedIds[value.sheetId], parentSheetId: replacedIds[value.parentSheetId], goodsId: data.goods_id, version: data.version }));
        else dispatch(addSheetTree({ ...value, bookId: replacedIds[value.bookId], sheetId: replacedIds[value.sheetId], goodsId: data.goods_id, version: data.version }));
      })
      sheetInformations.forEach(data => {
        const value = JSON.parse(data.jdoc);
        if (!('sheetId' in value)) return;
        dispatch(addSheetInformation({ ...value, sheetId: replacedIds[value.sheetId], goodsId: data.goods_id, version: data.version }));
      })

      let waitingCards: DataType[] = [];
      cards.forEach(data => {
        const value = JSON.parse(data.jdoc);
        if (!('sheetId' in value)) return;
        if (('parentId' in value && value.parentId) || value.groupParent) {
          waitingCards.push(data);
          return;
        }
        const newId = generateCardId();
        replacedIds[data.original_id] = newId;
        const newValue = { ...value, id: newId, sheetId: replacedIds[value.sheetId], cardTemplateId: '', goodsId: data.goods_id, version: data.version };
        if ('links' in value && value.links && Array.isArray(value.links)) newValue.links = value.links.map((sheetId: string) => replacedIds[sheetId]);
        dispatch(addCard(newValue));
      })
      let doneIds: string[] = [];
      while (waitingCards.length >= 1) {
        waitingCards.forEach(data => {
          const value = JSON.parse(data.jdoc);
          if (!('sheetId' in value)) return;
          if (('parentId' in value && value.parentId && !replacedIds[value.parentId]) || (value.groupParent && !replacedIds[value.groupParent])) {
            return;
          }
          const newId = generateCardId();
          replacedIds[data.original_id] = newId;
          if ('parentId' in value && value.parentId) {
            const newValue = { ...value, id: newId, sheetId: replacedIds[value.sheetId], parentId: replacedIds[value.parentId], cardTemplateId: '', goodsId: data.goods_id, version: data.version };
            if ('links' in value && value.links && Array.isArray(value.links)) newValue.links = value.links.map((sheetId: string) => replacedIds[sheetId]);
            dispatch(addCard(newValue));
          } else if (value.groupParent) {
            const newValue = { ...value, id: newId, sheetId: replacedIds[value.sheetId], groupParent: replacedIds[value.groupParent], cardTemplateId: '', goodsId: data.goods_id, version: data.version };
            if ('links' in value && value.links && Array.isArray(value.links)) newValue.links = value.links.map((sheetId: string) => replacedIds[sheetId]);
            dispatch(addCard(newValue));
          }
          doneIds.push(data.original_id);
        })
        waitingCards = waitingCards.filter(data => !doneIds.includes(data.original_id));
      }

      cardAttributes.forEach(data => {
        const value = JSON.parse(data.jdoc);
        if (!('cardId' in value)) return;
        dispatch(addCardAttribute({ ...value, cardId: replacedIds[value.cardId], goodsId: data.goods_id, version: data.version }));
      })
      cardShapes.forEach(data => {
        const value = JSON.parse(data.jdoc);
        if (!('cardId' in value)) return;
        dispatch(addCardShape({ ...value, cardId: replacedIds[value.cardId], goodsId: data.goods_id, version: data.version }));
      })
      drawCardContents.forEach(data => {
        const value = JSON.parse(data.jdoc);
        if (!('cardId' in value)) return;
        dispatch(addDrawCardContent({ ...value, cardId: replacedIds[value.cardId], goodsId: data.goods_id, version: data.version }));
      })
      memoCardContents.forEach(data => {
        const value = JSON.parse(data.jdoc);
        if (!('cardId' in value)) return;
        dispatch(addMemoCardContent({ ...value, cardId: replacedIds[value.cardId], goodsId: data.goods_id, version: data.version }));
      })
      arrows.forEach(data => {
        const value = JSON.parse(data.jdoc);
        if (!('sheetId' in value) || !('fromId' in value) || !('toId' in value)) return;
        const newValue = { ...value, sheetId: replacedIds[value.sheetId], fromId: replacedIds[value.fromId], toId: replacedIds[value.toId], goodsId: data.goods_id, version: data.version };
        if ('links' in value && value.links && Array.isArray(value.links)) newValue.links = value.links.map((sheetId: string) => replacedIds[sheetId]);
        dispatch(addArrow(newValue));
      })
    } catch (err) {
      console.log(err);
    }
  }
  return installGoods;
}

export default useInstallGoods;
